<!-- 分页组件 -->
<template>
    <div class="c-page">
        <Page :total="listData.total" :current="listData.pageNum" show-elevator show-sizer class="page-content"
            @on-change="changePageNum" @on-page-size-change="changePageSize" />
    </div>
</template>

<script>
    export default {
        name: 'CPage',
        props: {
            listData: {
                type: Object,
                default() {
                    return {
                        total: 0
                    }
                }
            }
        },
        data() {
            return {
                pageSize: 10,
                pageNum: 1
            }
        },
        watch: {
            'listData.pageNum': function (val) {
                return parseInt(val);
            }
        },
        mounted() {

        },
        methods: {
            // 请求,改变页码后查询
            changePageNum(val) {
                this.pageNum = val;
                this.$emit("buildAccrualListReq", { pageNum: this.pageNum, pageSize: this.pageSize });
            },

            // 请求,改变每页条数后查询
            changePageSize(val) {
                this.pageSize = val;
                this.$emit("buildAccrualListReq", { pageNum: this.pageNum, pageSize: this.pageSize });
            }
        },
    }
</script>

<style scoped>
    .c-page {
        position: relative;
        padding: 40px;
    }

    .page-content {
        text-align: center;
    }
</style>